const style = (theme) => {
  const output = {
    root: {
      fontSize: 14,
      fontFamily: theme.fonts[0],
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      transition: `all 0.75s ${theme.easings.garret}`,
      '& span': {
        marginRight: 20,
        whiteSpace: 'nowrap',
      },
    },
    circle: {
      position: 'relative',
      zIndex: 2,
      width: 34,
      height: 34,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: `all 0.75s ${theme.easings.garret}`,
      backfaceVisibility: 'hidden',
      willChange: 'transform',
      '&::before': {
        content: '""',
        position: 'absolute',
        zIndex: 0,
        top: 'calc(50% - 17px)',
        left: 'calc(50% - 17px)',
        borderRadius: '50%',
        width: '100%',
        height: '100%',
        animation: '$pulse 2s ease-in infinite',
      },
    },
    arrow: {
      position: 'relative',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '4px 3.5px 0 3.5px',
      backfaceVisibility: 'hidden',
      willChange: 'transform',
      transition: `all 0.75s ${theme.easings.garret}`,
    },
    rootColorLight: {
      color: 'transparent',
      textShadow: `0 10px transparent, 0 0 ${theme.colors[1]}`,
      '& $circle': {
        backgroundColor: theme.getRgba(theme.colors[4], 0.2),
        '&::before': {
          backgroundColor: theme.getRgba(theme.colors[4], 0.2),
        },
      },
      '& $arrow': {
        borderColor: `${theme.colors[1]} transparent transparent transparent`,
      },
      '@media (hover: hover)': {
        '&:hover': {
          textShadow: `0 0 ${theme.colors[1]}, 0 -10px transparent`,
          '& $circle': {
            backgroundColor: theme.getRgba(theme.colors[1], 0.5),
            '&::before': {
              backgroundColor: theme.getRgba(theme.colors[1], 0.2),
            },
          },
          '& $arrow': {
            borderColor: `${theme.colors[3]} transparent transparent transparent`,
          },
        },
      },
    },
    rootColorDark: {
      color: 'transparent',
      textShadow: `0 10px transparent, 0 0 ${theme.colors[3]}`,
      '& $circle': {
        backgroundColor: theme.getRgba(theme.colors[4], 0.2),
        '&::before': {
          backgroundColor: theme.getRgba(theme.colors[4], 0.2),
        },
      },
      '& $arrow': {
        borderColor: `${theme.colors[3]} transparent transparent transparent`,
      },
      '@media (hover: hover)': {
        '&:hover': {
          textShadow: `0 0 ${theme.colors[3]}, 0 -10px transparent`,
          '& $circle': {
            backgroundColor: theme.colors[3],
            '&::before': {
              backgroundColor: theme.getRgba(theme.colors[3], 0.2),
            },
          },
          '& $arrow': {
            borderColor: `${theme.colors[1]} transparent transparent transparent`,
          },
        },
      },
    },
    '@keyframes pulse': {
      '0%': {
        opacity: 0,
      },
      '50%': {
        opacity: 0.45,
      },
      '100%': {
        opacity: 0,
        transform: 'scale(1.6)',
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}

export default style
